import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FooterModule } from '@components/ui/footer/footer.module';
import { HeaderModule } from '@components/ui/header/header.module';
import { LayoutModule } from '@components/ui/layout/layout.module';
import { SidebarModule } from "@components/ui/sidebar/sidebar.module";
import { AuthGuard, NoAuthGuard, RoleGuard } from '@core/guards';
import { ROUTER_UTILS } from '@core/utils/router.utils';
import { NotFoundComponent } from '@pages/not-found/not-found.component';
import { NotFoundModule } from '@pages/not-found/not-found.module';
import { PDFViewerComponent } from '@pages/settings/pdfviewer/pdfviewer.component';
import { SplitTableComponent } from './pages/ecommerce/components/searched-items-result/split-table/split-table.component';

const APP_ROUTES: Routes = [
  {
    path: ROUTER_UTILS.config.auth.root,
    loadChildren: async () => (await import('@pages/auth/auth.module')).AuthModule,
    canLoad: [NoAuthGuard],
  },
  {
    path: ROUTER_UTILS.config.base.home,
    pathMatch: 'full',
    redirectTo: `/${ROUTER_UTILS.business.dashboard}`,
    canLoad: [AuthGuard],
  },
  {
    path: ROUTER_UTILS.business.bi,
    loadChildren: async () => (await import('@pages/bi/bi.module')).BiModule,
    canLoad: [AuthGuard],
    canActivate: [RoleGuard],
  },
  {
    path: ROUTER_UTILS.business.pdfViewer,
    component: PDFViewerComponent,
    data: {},
  },
  {
    path: ROUTER_UTILS.business.splitData,
    component: SplitTableComponent,
    canLoad: [AuthGuard],
    data: {},
  },
  {
    path: ROUTER_UTILS.business.smb,
    loadChildren: async () => (await import('@pages/smb/smb.module')).SmbModule,
    canLoad: [AuthGuard],
  },
  {
    path: ROUTER_UTILS.business.dashboard,
    loadChildren: async () => (await import('@pages/dashboard/dashboard.module')).DashboardModule,
    canLoad: [AuthGuard],
    canActivate: [RoleGuard],
  },
  {
    path: ROUTER_UTILS.config.settings.root,
    loadChildren: async () => (await import('@pages/settings/settings.module')).SettingsModule,
    canLoad: [AuthGuard],
    canActivate: [RoleGuard],
    data: {
      breadcrumb: 'Settings',
    },
  },
  {
    path: ROUTER_UTILS.config.user.root,
    loadChildren: async () => (await import('@pages/user/user.module')).UserModule,
    canLoad: [AuthGuard],
    canActivate: [RoleGuard],
  },
  {
    path: ROUTER_UTILS.business.ecommerce,
    loadChildren: async () => (await import('@pages/ecommerce/ecommerce.module')).EcommerceModule,
    canLoad: [AuthGuard],
    canActivate: [RoleGuard],
    data: {
      //regex:/^[(SEARCH)|(STORE)|(TREND)]$/
    }
  },
  {
    path: ROUTER_UTILS.business.incentive.root,
    loadChildren: async () => (await import('@pages/incentive/incentive.module')).IncentiveModule,
    canLoad: [NoAuthGuard],
  },
  {
    path: '**',
    loadChildren: async () => (await import('@pages/not-found/not-found.module')).NotFoundModule,
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(APP_ROUTES), SidebarModule, HeaderModule, FooterModule, LayoutModule, NotFoundModule],
  exports: [RouterModule, FooterModule, SidebarModule, HeaderModule, LayoutModule, NotFoundModule],
})
export class AppRoutingModule {}
